import { AxiosInstance } from 'axios';
import { Course } from './types';

export function coursesApi(client: AxiosInstance) {
  return {
    getList: () =>
      client.post<{ items: Course[] }>('/api/v1/admin/courses/get-list', {}),
    getById: (id: number) =>
      client.post<Course>('/api/v1/admin/courses/get-by-id', { id }),
    create: (data: Omit<Course, 'id'>) =>
      client.post<Course>('/api/v1/admin/courses/create', data),
    update: (data: Course) =>
      client.post<Course>('/api/v1/admin/courses/update', data),
  };
}
